import {
    Box,
    Divider,
    IconButton,
    MenuItem,
    Popper,
    useTheme,
} from "@common";
import React, { useRef, useState } from "react";

const CommonHoverPopper = ({
    icon,
    menuItems = [],
    placement = "right-start",
    iconSx = {},
    popupSx = {},
}) => {
    const theme = useTheme();

    const [anchorEl, setAnchorEl] = useState(null);
    const hoverZoneRef = useRef(null);

    const handleMouseEnter = () => {
        setAnchorEl(hoverZoneRef.current);
    };

    const handleMouseLeave = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const visibleItems = menuItems.filter(
        (item) => item.permission !== false
    );
    return (
        <Box
            ref={hoverZoneRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <IconButton
                sx={{
                    color: open ? "#00527d" : "#808080",
                    ...iconSx,
                }}
            >
                {typeof icon === "function"
                    ? React.createElement(icon, { open })
                    : icon}
            </IconButton>

            <Popper
                open={open}
                anchorEl={anchorEl}
                placement={placement}
            >
                <Box
                    sx={{
                        borderRadius: "12px",
                        overflow: "hidden",
                        boxShadow: theme.shadows[6],
                        background: theme.palette.background.paper,
                        px: 0.5,
                        ...popupSx,
                    }}
                >
                    {visibleItems.map((item, index) => (
                        <React.Fragment key={item?.label}>
                            <MenuItem onClick={item.onClick}
                            >
                                {item.icon && (
                                    <span
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            marginRight: "8px",
                                        }}
                                    >
                                        {item.icon}
                                    </span>
                                )}
                                {item.label}
                            </MenuItem>

                            {index !== visibleItems.length - 1 && (
                                <Divider
                                    sx={{
                                        background: "gray",
                                        marginTop: "1px !important",
                                        marginBottom: "1px !important",
                                    }}
                                />
                            )}
                        </React.Fragment>
                    ))}
                </Box>
            </Popper>
        </Box>
    );
};

export default CommonHoverPopper;